import React, { useRef } from "react";
import auth from "../../../providers/Auth.Provider";
import { UPDATE_PASSWORD, UPDATE_PHONE } from "../../../queries/staff.query";
import { useMutation } from "@apollo/react-hooks";
import LoadingSpinner from "../../../partials/loading";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../util/app";

function StaffSetting({ history, location, match }) {
    // local state
    const { GetToken, GetAuthenticatedStaff, LogOut } = auth.authProvider;
    const { mobile } = GetToken() && GetAuthenticatedStaff();
    // local reference
    const newPassword = useRef();
    const currentPassword = useRef();
    const mobileRef = useRef();
    setTimeout(() => {
        if (mobileRef && mobileRef.current) {
            mobileRef.current.value = mobile;
        }
    }, 0);
    // Update password function
    const [updatePasswordFunc, { loading: passwordLoading }] = useMutation(UPDATE_PASSWORD, {
        onCompleted: (data) => {
            if (data.UpdateCurrentPassword) {
                toast.success("Password Changed Successfully! You need to login with your new password");
                LogOut();
                history.push(`/login?redirect=${location.pathname}`);
            }
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    const [updatePhoneFunc, { loading: phoneLoading }] = useMutation(UPDATE_PHONE, {
        onCompleted: (data) => {
            if (data.UpdateMobileNumber) {
                toast.success(data.UpdateMobileNumber.message);
            }
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    const title = "Profile Settings";

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <div className="row justify-content-center">
                <div className="col-md-4 col-12">
                    <div className="card">
                        <div className="card-head">
                            <header>Change of Password</header>
                        </div>
                        <div className="card-body" style={{ minHeight: "250px" }}>
                            <form
                                onSubmit={async (event) => {
                                    event.preventDefault();
                                    await updatePasswordFunc({
                                        variables: {
                                            current: currentPassword.current.value,
                                            newPassword: newPassword.current.value,
                                        },
                                    });
                                }}
                            >
                                <div className="form-group">
                                    <label htmlFor="cPassword">Current Password</label>
                                    <input required type="password" placeholder="Enter password" name="cPassword" id="cPassword" ref={currentPassword} className="form-control input-height" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="nPassword">New Password</label>
                                    <input required type="password" placeholder="Enter password" name="nPassword" id="nPassword" ref={newPassword} className="form-control input-height" />
                                </div>
                                <div className="text-center">
                                    <LoadingSpinner loading={passwordLoading} />
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                                        Update Password <i className="material-icons">arrow_right_alt</i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <div className="card">
                        <div className="card-head">
                            <header>Change of Mobile Number</header>
                        </div>
                        <div className="card-body" style={{ minHeight: "250px" }}>
                            <form
                                onSubmit={async (event) => {
                                    event.preventDefault();
                                    await updatePhoneFunc({
                                        variables: { phone: mobileRef.current.value },
                                    });
                                }}
                            >
                                <div className="form-group">
                                    <label htmlFor="mobile">Phone Number</label>
                                    <input required type="text" placeholder="Enter Mobile Number" name="mobile" id="mobile" ref={mobileRef} className="form-control input-height" />
                                </div>
                                <div className="text-center">
                                    <LoadingSpinner loading={phoneLoading} />
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                                        Update Phone Number <i className="material-icons">arrow_right_alt</i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StaffSetting;
